import { FC } from 'react';
import { IconProps } from '../../types';

export const Bronze: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_58169)"
      />
      <path
        d="M5.86619 3.588H7.36619C7.89419 3.6 8.37419 3.6 8.83019 3.936C9.13019 4.152 9.28619 4.404 9.37019 4.74C9.46619 5.136 9.47819 5.844 9.47819 5.868C9.47819 6.012 9.47819 6.768 9.09419 7.284C8.95019 7.464 8.79419 7.584 8.61419 7.728C8.85419 7.836 8.96219 7.896 9.05819 7.968C9.32219 8.184 9.62219 8.664 9.62219 9.492C9.62219 9.612 9.61019 10.416 9.39419 10.956C9.34619 11.064 9.26219 11.256 9.05819 11.484C8.65019 11.904 8.18219 11.952 7.97819 11.976C7.58219 12.024 6.83819 12.024 5.86619 12.024V3.588ZM7.05419 8.172V11.028C7.43819 11.028 7.79819 11.028 8.07419 10.764C8.30219 10.56 8.43419 10.296 8.43419 9.696C8.43419 9.612 8.42219 9.024 8.21819 8.64C8.18219 8.58 8.11019 8.46 7.94219 8.352C7.67819 8.172 7.37819 8.172 7.05419 8.172ZM7.05419 4.56V7.26C7.64219 7.272 7.84619 7.212 8.06219 6.984C8.23019 6.792 8.36219 6.516 8.36219 5.94C8.36219 5.856 8.36219 5.664 8.31419 5.436C8.29019 5.28 8.20619 4.704 7.64219 4.56C7.45019 4.512 7.24619 4.536 7.05419 4.56Z"
        fill="#FCF7DE"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6141_58169"
          x1="7"
          y1="18"
          x2="7"
          y2="-3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90674D" />
          <stop offset="0.239" stopColor="#6A2D20" />
          <stop offset="0.464" stopColor="#DFC4A1" />
          <stop offset="1" stopColor="#9B725A" />
        </linearGradient>
      </defs>
    </svg>
  );
};
